import { Component, OnInit } from '@angular/core';
import {NgbDate, NgbCalendar, NgbDateParserFormatter} from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment'; //moment.js
import {ServicioFechasQueryService} from '../servicio-fechas-query.service'

@Component({
  selector: 'app-rangodefechas',
  templateUrl: './rangodefechas.component.html',
  styleUrls: ['./rangodefechas.component.scss'],
  styles: [`
    .form-group.hidden {
      width: 0;
      margin: 0;
      border: none;
      padding: 0;
    }
    .custom-day {
      text-align: center;
      padding: 0.185rem 0.25rem;
      display: inline-block;
      height: 2rem;
      width: 2rem;
    }
    .custom-day.focused {
      background-color: #e6e6e6;
    }
    .custom-day.range, .custom-day:hover {
      background-color: rgb(2, 117, 216);
      color: white;
    }
    .custom-day.faded {
      background-color: rgba(2, 117, 216, 0.5);
    }
  `]
})
export class RangodefechasComponent implements OnInit {

  fechaquerymin;
  fechaquerymax;

  formatDate(date: NgbDate) {
    // NgbDates use 1 for Jan, Moement uses 0, must substract 1 month for proper date conversion
    var ngbObj =  JSON.parse(JSON.stringify(date));
    var newMoment = moment();

    if (ngbObj) {
      ngbObj.month--;
      newMoment.month(ngbObj.month);
      newMoment.date(ngbObj.day);
      newMoment.year(ngbObj.year);
    }
    // Convert date to "Mon Feb 01" format
    if (newMoment.isValid()) {
      return newMoment.format('YYYY-MM-DD');
    } else {
      return '';
    }
  }

  hoveredDate: NgbDate | null = null;
  fromDate: NgbDate | null;
  toDate: NgbDate | null;

  constructor(private calendar: NgbCalendar, public formatter: NgbDateParserFormatter, public servicioFechasQueryService:ServicioFechasQueryService) {
    // this.fromDate = calendar.getToday();
    // this.toDate = calendar.getNext(calendar.getToday(), 'd', 10);//hace que la fecha final sea 10 dias después de hoy
    this.fromDate = calendar.getPrev(calendar.getToday(),"d",8)//hace que la fecha inicial sea 8 dias antes que hoy
    this.toDate = calendar.getToday();
  }


  ngOnInit(): void {
  }
  onDateSelection(date: NgbDate) {
    console.log("onDateSelection acvtivado")
    if (!this.fromDate && !this.toDate) {
      this.fromDate = date;
 
    } else 
    if (this.fromDate && !this.toDate && date && date.after(this.fromDate)) {
      this.toDate = date;

      //ACA SE DISPARA CUANDO HAY SELECCION DE FECHAS VALIDAS

      this.servicioFechasQueryService.fechaquerymin  = this.formatDate(this.fromDate);
      this.servicioFechasQueryService.fechaquerymax  = this.formatDate(this.toDate);
      console.log("Fechaquerymin en servicio: "+this.servicioFechasQueryService.fechaquerymin)
      console.log("Fechaquerymax en servicio: "+this.servicioFechasQueryService.fechaquerymax)
      //---------------------

    } else {
      this.toDate = null;
      this.fromDate = date;
    }
  }

  isHovered(date: NgbDate) {
    return this.fromDate && !this.toDate && this.hoveredDate && date.after(this.fromDate) && date.before(this.hoveredDate);
  }

  isInside(date: NgbDate) {
    return this.toDate && date.after(this.fromDate) && date.before(this.toDate);
  }

  isRange(date: NgbDate) {
    return date.equals(this.fromDate) || (this.toDate && date.equals(this.toDate)) || this.isInside(date) || this.isHovered(date);
  }

  // validateInput(currentValue: NgbDate | null, input: string): NgbDate | null {
  //   const parsed = this.formatter.parse(input);
    
  //   return parsed && this.calendar.isValid(NgbDate.from(parsed)) ? NgbDate.from(parsed) : currentValue;
   
  // }


}
